export default "__VITE_ASSET__d59638a4__"